const QUERIES = {
  USERS_LIST: 'users-list',
  RESELLERS_LIST:'resellers-list',
  ORDERS_LIST:'orders-list',
  COUNTRIES_LIST:'countries_list',
  BUNDLES_LIST:'bundles_list',
}

export {QUERIES}
